// src/features/communities/filterCommunities.ts — pure directory helpers.
import type { Community } from '@/core/models/community';
import type { Post } from '@/core/models/post';

/** Case-insensitive substring match on name + category. Empty query → unchanged. */
export function searchCommunities(list: Community[], q: string): Community[] {
  const needle = q.trim().toLowerCase();
  if (!needle) return list;
  return list.filter(
    (c) => c.name.toLowerCase().includes(needle) || c.category.toLowerCase().includes(needle),
  );
}

/** All communities sorted by member count desc (the Popular cover-art grid). */
export function popularCommunities(list: Community[]): Community[] {
  return [...list].sort((a, b) => b.membersNum - a.membersNum);
}

/** Only recommended communities (the Recommended-for-You grid). */
export function recommendedCommunities(list: Community[]): Community[] {
  return list.filter((c) => c.recommended);
}

/** Resolve a community's postIds to Post records (skipping any not found), preserving order. */
export function communityPosts(postIds: string[], posts: Post[]): Post[] {
  return postIds
    .map((id) => posts.find((p) => p.id === id))
    .filter((p): p is Post => p !== undefined);
}
